class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.setupHoverDisclosures();
  }

  setupHoverDisclosures() {
    this.querySelectorAll('details').forEach((details) => {
      const summary = details.querySelector('summary');
      if (!summary) return;
      let closeTimeout;
      const cancelClose = () => clearTimeout(closeTimeout);
      const scheduleClose = () => {
        clearTimeout(closeTimeout);
        closeTimeout = setTimeout(() => this.closeOnHover(details, summary), 300);
      };

      details.addEventListener('mouseenter', () => {
        cancelClose();
        this.openOnHover(details, summary);
      });
      details.addEventListener('mouseleave', scheduleClose);

      details.addEventListener('focusin', () => {
        cancelClose();
        this.openOnHover(details, summary);
      });
      details.addEventListener('focusout', (event) => {
        if (!details.contains(event.relatedTarget)) this.closeOnHover(details, summary);
      });

      summary.addEventListener('click', (event) => {
        event.preventDefault();
        summary.setAttribute('aria-expanded', details.hasAttribute('open'));

        const url = summary.dataset.url;
        if (url && url !== '#') window.location.href = url;
      });
    });
  }

  openOnHover(details, summary) {
    details.setAttribute('open', '');
    summary.setAttribute('aria-expanded', true);
  }

  closeOnHover(details, summary) {
    details.removeAttribute('open');
    summary.setAttribute('aria-expanded', false);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
